import { render, staticRenderFns } from "./Widget1N.vue?vue&type=template&id=05b29dcb&"
import script from "./Widget1N.vue?vue&type=script&lang=js&"
export * from "./Widget1N.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports